<script setup>
// Rodada mobile F2: em telas < md, a nav lateral interna de uma area de
// settings vira chips horizontais deslizaveis — mesmo dado, outra
// embalagem. Reutilizavel: recebe as MESMAS sections da nav vertical.
defineProps({
  sections: { type: Array, required: true },
  selected: { type: String, default: '' },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div
    class="md:hidden flex gap-2 overflow-x-auto px-4 py-2.5 border-b border-n-weak bg-n-solid-1 no-scrollbar"
  >
    <template v-for="section in sections" :key="section.label">
      <button
        v-for="item in section.items"
        :key="item.key"
        type="button"
        :disabled="!item.active"
        class="flex items-center gap-1.5 flex-shrink-0 rounded-full border px-3.5 py-1.5 text-[13px] font-medium whitespace-nowrap"
        :class="[
          selected === item.key
            ? 'bg-woot-500 border-woot-500 text-white'
            : 'bg-n-solid-1 border-n-weak text-n-slate-11',
          !item.active ? 'opacity-50' : '',
        ]"
        @click="emit('select', item)"
      >
        <span :class="item.icon" class="size-3.5" />
        {{ item.label }}
      </button>
    </template>
  </div>
</template>
